export default function Footer() {
  return <>
  <div className="row justify-content-center m-0 " style={{ background:"linear-gradient(to bottom, #d5f5e3, #FFFFFF)" }}  >
    <div className="col-md-6 col-sm-12" >
      <div className="text-center">
        <hr/>
          © 2025 Babyboo.dev, All rights reserved. 
        <br/>
        For~ inquiries, contact <a href="mailto:inbox@nandran.com">inbox@nandran.com</a>          
      </div>
    </div>
  </div>
  </>
}
